import Select from 'react-select';
import React from 'react';
import { toast } from 'react-toastify';

const MarqueeModal = ({
    isOpen,
    setIsOpen,
    marquee,
    handleInputChange,
    handleAddAmenities,
    handleStatusChange,
    handleTypeChange,
    TypeOptions,
    statusOptions,
    handleUpdateAmenities
}) => {
    console.log(marquee.status)
    const validateLink = (link) => {
        return link.startsWith("http");
    };
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" 
        // onClick={() => setIsOpen(false)}
        >
            <div className="custom-modal-content" >
                <h2 className="oms-modal-title">Add Text Ads</h2>
                <form
                    className="oms-modal-form"
                    onSubmit={(e) => {
                        e.preventDefault();

                        if (marquee.link && !/^https?:\/\//i.test(marquee.link)) {
                            toast.error("Link must start with http or https");
                            return;
                        }

                        if (marquee.id) {
                            handleUpdateAmenities(); // if editing
                        } else {
                            handleAddAmenities(); // if adding
                        }
                    }}
                      
                >
                    
                    <div className="oms-form-group">
                        <label htmlFor="heading" className="oms-form-label">Heading</label>
                        <input
                            type="text"
                            id="heading"
                            name="heading"
                            value={marquee.heading}
                            onChange={(e) => {
                                if (e.target.value.length <= 60) {
                                    handleInputChange(e);
                                }
                            }}
                            placeholder="Enter Heading (Max 60 characters)"
                            required
                        />
                        <small style={{ fontSize: "12px", color: "gray", float: "right", marginTop: "5px" }}>{marquee.heading.length}/60</small>
                    </div>

                    
                    <div className="oms-form-group">
                        <label htmlFor="security" className="oms-form-label">Sub Heading</label>
                        <input
                            type="text"
                            id="sub_heading"
                            name="sub_heading"
                            value={marquee.sub_heading}
                            onChange={(e) => {
                                if (e.target.value.length <= 100) {
                                    handleInputChange(e);
                                }
                            }}
                            placeholder="Enter Sub Heading (Max 100 characters)"
                            required
                        />
                        <small style={{ fontSize: "12px", color: "gray", float: "right", marginTop: "5px" }}>{marquee.sub_heading.length}/100</small>
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Type
                        </label>
                        <Select options={TypeOptions}
                            placeholder="Select Type"
                            value={TypeOptions.find(option => option.value === marquee.type)}
                            onChange={handleTypeChange}
                            required
                        />
                    </div>
                    {
                        marquee.type === "End Date" ? <div className="oms-form-group">
                            <label htmlFor="date" className="oms-form-label">Date</label>
                            <input
                                type="date"
                                id="date"
                                name="date"
                                value={marquee.date}
                                onChange={handleInputChange}
                                placeholder="Enter date"
                                required
                            />
                        </div> : null
                    }
                    <div className="oms-form-group">
                        <label htmlFor="link" className="oms-form-label">Link</label>
                        <input
                            type="text"
                            id="link"
                            name="link"
                            value={marquee.link}
                            onChange={handleInputChange}
                            placeholder="Enter link"
                            
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions}
                            placeholder="Select status"
                            value={statusOptions.find(option => option.value === marquee.status)}
                            onChange={handleStatusChange}

                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">
                            {marquee.id ? "Update" : "Add"}
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default MarqueeModal;
